<button mat-button class="menu-button" (click)="clicked.emit()">
  <a
    class="menu-item"
    [routerLink]="item.url"
    [queryParams]="item.queryParams"
    *ngIf="!item.onClick"
  >
    <fa-icon *ngIf="item.faIcon" [icon]="item.faIcon"></fa-icon>

    <p class="ms-2 my-0">{{ item.label }}</p>
    <fa-icon
      [icon]="faChevronDown"
      class="more-icon"
      *ngIf="item.children?.length"
      [class.activated]="isMenuActivated"
    ></fa-icon>
  </a>

  <span class="menu-item" *ngIf="item.onClick">
    <fa-icon *ngIf="item.faIcon" [icon]="item.faIcon"></fa-icon>
    <p class="ms-2 my-0">{{ item.label }}</p>
    <fa-icon
      [icon]="faChevronDown"
      class="more-icon"
      *ngIf="item.children?.length"
      [class.activated]="isMenuActivated"
    ></fa-icon>
  </span>
</button>

<div
  class="menu-children"
  *ngIf="item.children?.length"
  [class.inactivated]="!isMenuActivated"
  [ngStyle]="getItemStyle()"
>
  <ng-container *ngFor="let child of item.children">
    <a
      mat-button
      class="menu-button"
      [routerLink]="child.url"
      [queryParams]="child.queryParams"
      *ngIf="!child.onClick && !child.children?.length; else menuItem"
      (click)="subMenuClicked.emit()"
    >
      <div class="menu-item">
        <p class="ms-2 my-0">{{ child.label }}</p>
      </div>
    </a>

    <ng-template #menuItem>
      <app-sidenav-menu-item
        [item]="child"
        [isMenuActivated]="activatedChild === child"
        (clicked)="toggleActivatedChild(child)"
        (subMenuClicked)="clearActivatedChild(); clicked.emit()"
      />
    </ng-template>
  </ng-container>
</div>
